<template>
  <div class="navigation">
    <video autoplay muted loop class="backgroundVideo">
      <source :src="background_link" type="video/mp4" />
    </video>
    <img id="menuTrigger" :src="menu_link" class="menu_icon action--menu" />
    <router-link to="/" class="logo"><img :src="logo_link" /></router-link>
    <nav id="menuDisplay" class="menu">
      <img :src="close_link" class="close_icon action--close" />
      <div class="menu__item menu__item--1" data-direction="bt">
        <div class="menu__item-inner">
          <h3>
            We drive change.<br />Ideas are catalysts.<br />Ready to launch
            yours?
          </h3>
          <p>
            Our services are the vehicles that deliver change—problems solved,
            policies advanced, opinions shaped, lives transformed. You name it.
            We deliver.
          </p>
          <a href="#" class="btn page-impact">Our impact</a>
        </div>
      </div>
      <div class="menu__item menu__item--2" data-direction="lr">
        <div class="menu__item-inner">
          <div class="intro">
            <h3>Who We Are</h3>
            <p>
              Our ability to move people and drive change stems from our
              all-star team.
            </p>
            <a href="#" class="btn btn-introteam">Meet Our Team</a>
          </div>
          <div class="slideshow">
            <img
              v-bind:key="image.id"
              v-for="image in slider_images"
              :src="image.url"
              class="slide_images"
            />
          </div>
        </div>
      </div>
      <div class="menu__item menu__item--3" data-direction="bt">
        <div class="menu__item-inner">
          <div class="sidemenu">
            <a href="#" class="sidemenu__item page-home"
              ><span class="sidemenu__item-inner">Our Team</span>
              <div class="line"></div
            ></a>
            <a href="#" class="sidemenu__item page-team"
              ><span class="sidemenu__item-inner">Our Team</span>
              <div class="line"></div
            ></a>
            <a href="#" class="sidemenu__item page-news"
              ><span class="sidemenu__item-inner">Latest</span>
              <div class="line"></div
            ></a>
            <a href="#" class="sidemenu__item page-impact1"
              ><span class="sidemenu__item-inner">Impact</span>
              <div class="line"></div
            ></a>
            <a href="#" class="sidemenu__item page-contact"
              ><span class="sidemenu__item-inner">Connect</span>
              <div class="line"></div
            ></a>
          </div>
        </div>
      </div>
      <div class="menu__item menu__item--4" data-direction="rl">
        <div class="menu__item-inner fixed-container">
          <h3>Let's talk</h3>
          <p>
            When you work with us, your issue becomes our issue. You have a
            mission, so let’s do it together.
          </p>
          <a href="#" class="contact-btn page-contact">Contact Us</a>
          <div class="social-part">
            <div class="social-icon">
              <a
                href="https://www.facebook.com/PerryCommunications"
                target="_blank"
                rel="noopener"
                ><font-awesome-icon
                  :icon="['fab', 'facebook-f']"
                  :style="{ color: '#226BB5' }"
              /></a>
            </div>
            <div class="social-icon">
              <a
                href="https://twitter.com/PerryComGroup"
                target="_blank"
                rel="noopener"
                ><font-awesome-icon
                  :icon="['fab', 'twitter']"
                  :style="{ color: '#226BB5' }"
              /></a>
            </div>
            <div class="social-icon">
              <a
                href="https://www.linkedin.com/company/perry-communications"
                target="_blank"
                rel="noopener"
                ><font-awesome-icon
                  :icon="['fab', 'linkedin-in']"
                  :style="{ color: '#226BB5' }"
              /></a>
            </div>
          </div>
        </div>
      </div>
      <div class="menu__item menu__item--5" data-direction="tb">
        <div class="menu__item-inner fixed-container">
          <h3>#PCGNews</h3>
          <div class="news_content">
            <p v-bind:key="news.id" v-for="news in news_data">
              {{ news.post_title }}<br /><br />
            </p>
          </div>
          <a href="#" class="contact-btn page-news1">Read More Stories</a>
        </div>
      </div>
    </nav>
  </div>
</template>

<style>
.navigation {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
}
.backgroundVideo {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100vh;
  object-fit: cover;
}
.menu_icon {
  position: absolute;
  left: 20px;
  z-index: 999;
}
.logo {
  position: absolute;
  right: 20px;
  z-index: 999;
}
</style>

<script>
export default {
  data() {
    return {
      wpData: wpData,
      background_link: "",
      menu_link: "",
      menuIsOpen: false,
      logo_link: "",
      close_link: "",
      slider_images: [],
      news_data: [],
    };
  },
  mounted() {
    $('#menuTrigger').on('click', () => {
      this.menuIsOpen = true;
    });

    setTimeout(() => {
      if (!this.menuIsOpen) {
        $('#menuTrigger').trigger('click');
      }
    }, 4000);
    this.background_link =
      this.wpData.template_directory_uri + "/spa/assets/images/blueSparks.mp4";
    this.menu_link =
      this.wpData.template_directory_uri + "/spa/assets/images/menuicon.png";
    this.logo_link =
      this.wpData.template_directory_uri + "/spa/assets/images/logo.png";
    this.close_link =
      this.wpData.template_directory_uri + "/spa/assets/images/closeIcon.png";
    fetch(`${this.wpData.rest_url}/wp/v2/pagedata?page_title=Our Team`)
      .then((res) => res.json())
      .then((data) => {
        this.page_data = data;
        fetch(
          `${this.wpData.rest_url}/wp/v2/acfdata?post_id=${data.ID}&field_name=team_member`
        )
          .then((res) => res.json())
          .then((data1) => {
            this.slider_images = [];
            data1.forEach((element, index) => {
              var obj = { id: index, url: element.member_black_white_image };
              this.slider_images.push(obj);
            });
          });
      });

    var s = 0;

    this.wpData.pcgnews.forEach((element) => {
      s++;
      if (s < 3) {
        var news = {
          id: element.ID,
          image: element.featured_image,
          post_title: element.post_title,
          post_desc: element.post_content,
          link: "/news/" + element.ID,
        };
        this.news_data.push(news);
      }
    });

    let router = this.$router;
    $(".page-home").click(function () {
      setTimeout(function () {
        router.push("/");
      }, 800);
    });
    $(".page-team").click(function () {
      setTimeout(function () {
        router.push("/team");
      }, 800);
    });
    $(".btn-introteam").click(function () {
      setTimeout(function () {
        router.push("/team");
      }, 800);
    });
    $(".page-impact").click(function () {
      setTimeout(function () {
        router.push("/impact");
      }, 800);
    });
    $(".page-impact1").click(function () {
      setTimeout(function () {
        router.push("/impact");
      }, 800);
    });
    $(".page-news").click(function () {
      setTimeout(function () {
        router.push("/news");
      }, 800);
    });
    $(".page-news1").click(function () {
      setTimeout(function () {
        router.push("/news");
      }, 800);
    });
    $(".page-contact").click(function () {
      setTimeout(function () {
        router.push("/contact");
      }, 800);
    });
  },
  methods: {
    gotoMenuPage: function (event) {},
  },
};
</script>
<style>
.page-home {
  display: none !important;
}
.menu {
  text-align: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: repeat(3, 33.33%);
  pointer-events: none;
  z-index: 2000;
}

.menu .menu__item--1 {
  transform: translate(0%, 101%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--1 .menu__item-inner {
  transform: translate(0%, -101%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--2 {
  transform: translate(-101%, 0%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--2 .menu__item-inner {
  transform: translate(101%, 0%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--5 {
  transform: translate(0%, -101%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--5 .menu__item-inner {
  transform: translate(0%, 101%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--3 {
  transform: translate(0%, 101%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--3 .menu__item-inner {
  transform: translate(0%, -101%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--4 {
  transform: translate(101%, 0%) matrix(1, 0, 0, 1, 0, 0);
}

.menu .menu__item--4 .menu__item-inner {
  transform: translate(-101%, 0%) matrix(1, 0, 0, 1, 0, 0);
}

.menu--open .menu__item-inner {
  width: auto;
}

.menu--open {
  pointer-events: auto;
}

.menu__item {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.menu .menu__item-inner.fixed-container {
  padding: 30px 20px 20px 20px;
  justify-content: start;
}

.menu .menu__item--5 .menu__item-inner.fixed-container {
  padding-right: 50px;
  padding-left: 50px;
}

.menu__item-inner {
  overflow: hidden;
  transform: translate3d(100%, 0, 0);
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.menu__item--1 .menu__item-inner {
  background: rgba(23, 44, 98, 0.85);
}
.menu__item--2 .menu__item-inner {
  background: #fff;
  position: relative;
}
.menu__item--3 .menu__item-inner {
  background: #172c62;
}
.menu__item--4 .menu__item-inner {
  background: rgba(24, 107, 181, 0.9);
  padding: 0 50px;
}
.menu__item--5 .menu__item-inner {
  background: #2e55a5;
  padding: 0 50px;
}

.menu__item--4,
.menu__item--5 {
  display: none;
}

.label {
  display: none;
}

.mainmenu__item {
  opacity: 0;
}

.action {
  background: none;
  border: 0;
  color: #fff;
  cursor: pointer;
  padding: 0;
}

.action--menu {
  pointer-events: auto;
  position: absolute;
  right: 1.5rem;
  z-index: 1000;
}

.menu--open .action--menu {
  pointer-events: none;
}

.action--close {
  position: absolute;
  top: 1.5rem;
  right: 1.75rem;
  z-index: 1000;
  opacity: 0;
  padding: 0 0.5rem;
}

.menu--open .action--close {
  z-index: 1000;
}

.menu__item-inner h3 {
  font-size: 35px;
  color: #fff;
}

.menu__item-inner p {
  margin-top: 5px;
  font-size: 19px;
  color: #fff;
}

.menu__item--5 h3 {
  align-self: flex-start;
}

.menu__item--5 .news_content {
  margin-top: 8px;
}

.menu__item--5 p {
  line-height: 22px;
  text-decoration: none;
  display: inline;
  background-image: linear-gradient(
    to bottom,
    transparent 20%,
    currentColor 21%
  );
  background-position: 0 20px;
  background-repeat: no-repeat;
  background-size: 0% 6px;
  transition: background-size 0.5s ease-in-out 0.3s;
  margin: 10px 0;
}

.menu__item--5 p:hover,
.menu__item--5 p:focus {
  background-size: 100% 6px;
  transition-delay: 0s;
}

.menu__item--5 a {
  width: 130px;
  height: 28px;
  font-size: 15px;
  color: #fff;
  border: 1px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  align-self: flex-end;
}

.contact-btn {
  transition: all 0.2s ease-in-out;
}

.menu__item--4 .contact-btn {
  font-size: 20px;
  border: 1px solid #fff;
  color: #fff;
  text-decoration: none;
  margin-top: 5px;
  padding: 5px 10px;
}

.menu__item--5 .contact-btn {
  margin-top: 20px;
  width: auto;
  height: auto;
  padding: 5px 10px;
}

.menu__item--4 .contact-btn:hover {
  background: #fff;
  color: #226bb5;
}

.menu__item--5 .contact-btn:hover {
  background: #fff;
  color: #2e55a5;
}

.social-part {
  display: flex;
  margin-top: 20px;
  width: 100px;
  height: 35px;
  align-items: center;
  justify-content: space-between;
}

.social-icon {
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
}

.social-icon:hover {
  transform: scale(1.3);
}

.intro {
  width: 60%;
  position: absolute;
  top: 60px;
  left: 30px;
  text-align: left;
  align-self: flex-start;
  z-index: 1;
}

.intro h3,
.intro p,
.intro a {
  color: #172c62;
}

.intro .btn:hover {
  background: #172c62;
  color: #fff;
}

.intro .btn {
  background: #fff;
  border: 1px solid #172c62;
  border-radius: 0;
  transition: all 0.2s ease-in-out;
  z-index: 9999;
  position: relative;
}

.slideshow img {
  width: 100%;
  width: 350px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.menu__item--1 h3,
.menu__item--1 p {
  width: 60%;
}

.menu__item--1 h3 {
  font-size: 40px;
  line-height: 60px;
}

.menu__item--1 p {
  font-size: 17px;
  line-height: 25px;
  margin-top: 25px;
}

.menu__item--1 a.btn {
  margin-top: 30px;
  font-size: 40px;
  padding: 5px 20px;
  border: 2px solid #fff;
  color: #fff;
  border-radius: 0;
  transition: all 0.2s ease-in-out;
}

.menu__item--1 a.btn:hover {
  background: #fff;
  color: #172c62;
}

.sidemenu__item {
  font-size: 35px;
  line-height: 70px;
  color: #fff;
  position: relative;
}

.sidemenu__item .line {
  height: 2px;
  background: #fff;
  position: absolute;
  bottom: 13px;
  transition: width 0.5s;
  width: 0;
  left: 50%;
  transform: translateX(-50%);
}
.mainmenu,
.sidemenu {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.mainmenu {
  counter-reset: menuitem;
}

.sidemenu__item:hover {
  color: #fff;
  text-decoration: none;
}

.sidemenu__item:hover .line {
  width: 100%;
}

.sidemenu__item:hover span {
  width: 30px;
}

@media screen and (max-width: 768px) {
  .menu .menu__item--1,
  .menu .menu__item--2 {
    display: none;
  }
  .menu .menu__item--3 {
    height: 50vh;
  }
  .menu .menu__item--4 {
    height: 50vh;
    transform: none;
    display: block;
    position: absolute;
    top: 50vh;
  }
  .menu__item--4 .contact-btn {
    margin: 0 auto;
  }
  .menu__item--4 .social-part {
    margin: 20px auto;
  }
}

@media screen and (max-height: 600px) {
  .menu .menu__item--1,
  .menu .menu__item--5,
  .menu .menu__item--2 {
    display: none;
  }
  .menu.menu--open {
    display: flex;
  }
  .menu .menu__item--3,
  .menu .menu__item--4 {
    width: 50vw;
    height: 100vh;
  }

  .menu .menu__item--4 {
    transform: none;
    display: block;
    position: absolute;
    left: 50vw;
    top: 0;
  }
}

@media screen and (min-width: 768px) {
  .menu {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    grid-template-columns: 20% 30% 50%;
    grid-template-rows: 60% 40%;
    grid-template-areas:
      "item3 item2 item1"
      "item4 item5 item1";
  }
  .menu__item {
    height: 100%;
  }
  .menu__item--1 {
    grid-area: item1;
  }
  .menu__item--2 {
    grid-area: item2;
  }
  .menu__item--3 {
    grid-area: item3;
  }
  .menu__item--4 {
    grid-area: item4;
  }
  .menu__item--5 {
    grid-area: item5;
    text-align: left;
  }
  .menu__item--4,
  .menu__item--5 {
    display: block;
  }
  .menu__item-inner {
    align-items: center;
  }
}

@media screen and (max-width: 1000px), (max-height: 900px) {
  .menu__item-inner h3 {
    font-size: 24px;
    line-height: 28px;
  }

  .menu__item--1 .menu__item-inner h3 {
    font-size: 28px;
    line-height: 32px;
  }

  .menu__item-inner p {
    font-size: 16px;
  }

  .sidemenu__item {
    font-size: 24px;
  }

  .menu__item--4 .contact-btn,
  .menu__item--5 .contact-btn {
    font-size: 16px;
  }

  .menu__item--1 a.btn {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppNavigation.vue